<template>
    <div class="blocchetto-titolo">
        <span><img src="/img/be/ico-extra.png"> EXTRA</span>
        <br><br>
        <div class="row mx-0">
            <div class="col-12 col-md-4 col-sm-6 col-lg-3 col-xl-3" v-for="(extra, i) in this.extras">
                <label>{{ extra.traduzione.nome }}</label>
                <input type="text" class="form-control" v-if="extra.tipo === 'LIBERO'"
                       @input="(e) => changeFree(e, extra)">
                <div v-if="extra.tipo === 'SCELTA'" class="d-flex flex-row">
                    <!-- A.A. Decisione del 22/11/2021 extra default a SI -->
                    <mcw-radio v-if="extra.tipo === 'SCELTA'" @change="changeChoice(extra, 1)" :name="`extra_${i}`"
                               :label="$t('si')" :value="extra.id.toString()" checked class="mr-2"/>
                    <mcw-radio v-if="extra.tipo === 'SCELTA'" @change="changeChoice(extra, 0)" :name="`extra_${i}`"
                               :label="$t('no')" :value="extra.id.toString()"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Extras",
    props: ['extras'],
    data() {
        return {
            form: this.extras.map((extra) => {
                return {id: extra.id, value: extra.tipo === 'LIBERO' ? null : 1}
            })
        };
    },
    computed: {
        free_extras: function () {
            return this.extras.filter((extra) => extra.tipo === "LIBERO");
        },
        choice_extras: function () {
            return this.extras.filter((extra) => extra.tipo === "SCELTA");
        }
    },
    methods: {
        changeChoice: function (extra, value) {
            const index = this.form.findIndex(item => item.id === extra.id);
            if (index >= 0) this.form[index].value = value;

            this.$emit('onExtrasChange', this.form);
        },
        changeFree: function (e, extra) {
            const index = this.form.findIndex(item => item.id === extra.id);
            if (index >= 0) this.form[index].value = e.target.value !== '' ? e.target.value : null;

            this.$emit('onExtrasChange', this.form);
        }
    }
}
</script>